import React from 'react';
import styles from './Decloration.module.css';
import moment from "moment/moment";
import Button from "@mui/material/Button";
import EditIcon from '@mui/icons-material/Edit';
import { useNavigate } from "react-router-dom";

const DraftList = ({ draft, applicationTypes }) => {
    const navigate = useNavigate();
    const updatedAt = moment(draft.updated_at || draft.created_at);
    const now = moment();
    const duration = moment.duration(now.diff(updatedAt));

    const days = Math.floor(duration.asDays());
    const hours = Math.floor(duration.asHours() % 24);
    const formattedTime = days > 0
        ? `${days} дней и ${hours} часов назад`
        : `${hours} часов назад`;

    // Resolve type: from nested object or by application_type_id from applicationTypes
    const applicationTypeId = draft.application_type_id ?? draft.application_type?.id;
    const typeName = draft.application_type?.name
        ?? (Array.isArray(applicationTypes) && applicationTypeId
            ? applicationTypes.find(t => t.id === applicationTypeId || t.id === parseInt(applicationTypeId, 10))?.name
            : null)
        ?? 'Черновик заявления';

    const handleContinueDraft = () => {
        if (applicationTypeId) {
            navigate(`/declarations/${applicationTypeId}?draftId=${draft.id}`);
        } else {
            window.showAlert({
                title: 'Ошибка: у черновика не указан тип заявления',
                type: 'error'
            });
        }
    };

    return (
        <div className={styles.list}>
            <span className={styles.id}>Черновик #{draft.id} </span>
            <div style={{ flex: 1 }}>
                <span>{typeName}</span>
                <div className={styles.listBody}>
                    <div className={styles.status} style={{ background: '#E8EFFB', color: '#2F6FED' }}>
                        Черновик
                    </div>
                    <span className={styles.listTime} style={{ fontSize: '12px' }}>
                        Обновлено: {formattedTime}
                    </span>
                </div>
            </div>
            <Button
                onClick={handleContinueDraft}
                size="small"
                startIcon={<EditIcon />}
                style={{
                    minWidth: 'auto',
                    padding: '4px 8px',
                    fontSize: '12px',
                    textTransform: 'none',
                    color: '#666',
                    marginLeft: '10px',
                    border: 'none',
                    boxShadow: 'none',
                    textDecoration: 'none',
                    cursor: 'pointer'
                }}
                variant="text"
            >
                Продолжить
            </Button>
        </div>
    );
};

export default DraftList;
